// removed by extract-text-webpack-plugin
module.exports = {"invisible":"_3FIuwiphsPb71ysTZkg2aF","miniToolContainer":"_1NTUeRkT_Wp7HFuvNp7yDY","outerHeading":"_2khkYtBxFs2dLBH3ONg8Jw","maintenanceMsg":"_2lIpB8iLxVTV0Ce0Tv8405","mainPanelBody":"_1fbkHW8dlawmBoatXkZWZR"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Docs/Docs.scss
// module id = 833
// module chunks = 0